import ApiClient,{client} from './client';

export const authApi = {
  
  login: (username, user_pass, captcha) => {
  const temp_client = new ApiClient({redirect : '/', noRedirect : true });
  return temp_client.post('login', {
    username,
    user_pass,
    ...(captcha ? { captcha_key: captcha.key, captcha_answer: captcha.answer } : {}),
  })
    .then(response => {
      const { session_id } = response.data;

      if (session_id) {
        // Mirror the server cookie in JS so ApiClient can append session_id
        // to requests. Match the long server Max-Age (7 days) - previously
        // this was a session cookie while the HttpOnly one died at 15 min,
        // which made mid-session logouts look random.
        const maxAge = 7 * 24 * 60 * 60;
        document.cookie = `session_id=${session_id}; path=/; max-age=${maxAge}; SameSite=None; Secure`;
      }

      return response;
    })
    .catch(error => {
      console.error('Login failed:', error);
      throw error; // re-throw so the caller can handle it too
    });
},
  // Asks the server (session state) whether a login CAPTCHA is required and,
  // if so, issues a fresh challenge. Also used for the refresh button.
  getLoginCaptcha: () => client.get('login_captcha'),

  userLogin: (username, user_pass) =>
    client.post('user_login', { username, user_pass }),

  employeeLogin: (username, user_pass) =>
    client.post('employee_login', { username, user_pass }),

  logout: () =>
    client.get('logout'),

  signUp: (data) =>
    client.post('sign_up', data),

  checkUsernameDuplicate: (username) =>
    client.get('username_is_duplicated', { params: { username } }),

  generateAuthCode: (username, type, phone_number) =>
    client.get('generate_authentication_code', { params: { username, type, phone_number } }),

  registerInfo: (params) =>
    client.get('register_info', { params }),

  resetPassword: (params) =>
    client.get('reset_password', { params }),
};
